export const phoneRegex = /(^(\+88|0088|88)?(01){1}[3456789]{1}(\d){8})$/;

export const phoneRegexEmpty =
  /(^(\+88|0088|88)?(01){1}[3456789]{1}(\d){8})$|^$/;
